<template>
  <div class="sessions_wrap">
    <div class="toolbar">
      <!-- 记忆 / 会话管理 子 Tab：与数字员工页 Tab 样式一致 -->
      <div class="toolbar_left">
        <div class="staff_tabs">
          <span @click="$emit('switch-tab', 8)">记忆</span>
          <span class="active">会话管理</span>
        </div>
        <el-form :inline="true" :model="queryForm" class="query_form">
          <el-form-item label="数字员工">
            <el-select v-model="queryForm.agent_id" placeholder="全部" clearable filterable style="width: 200px">
              <el-option v-for="a in agentOptions" :key="a.agent_id"
                         :label="a.display_name || a.name" :value="a.agent_id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-button type="primary" icon="el-icon-plus" @click="openAdd">新建会话</el-button>
    </div>

    <el-table :data="tableData" v-loading="loading" border empty-text="暂无会话">
      <el-table-column label="会话标题" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.title || '新会话' }}</template>
      </el-table-column>
      <el-table-column label="所属数字员工" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">{{ agentName(scope.row.agent_id) }}</template>
      </el-table-column>
      <el-table-column label="创建时间" width="160">
        <template slot-scope="scope">{{ fmtTime(scope.row.ctime) }}</template>
      </el-table-column>
      <el-table-column label="最近活跃" width="160">
        <template slot-scope="scope">{{ fmtTime(scope.row.utime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openMessages(scope.row)">查看消息</el-button>
          <el-button type="text" size="small" @click="openRename(scope.row)">重命名</el-button>
          <el-button type="text" size="small" class="danger_text" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagesize"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />

    <!-- 新建会话（兜底入口，常规入口在 P2 Chat 内；个人/企业均可用） -->
    <el-dialog title="新建会话" :visible.sync="addVisible" width="480px" v-dialogDrag
               :modal-append-to-body="false" v-if="addVisible">
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="90px">
        <el-form-item label="数字员工" prop="agent_id">
          <el-select v-model="addForm.agent_id" filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="a in activeAgents" :key="a.agent_id"
                       :label="a.display_name || a.name" :value="a.agent_id" />
          </el-select>
        </el-form-item>
        <el-form-item label="会话标题">
          <el-input v-model="addForm.title" maxlength="64" placeholder="留空则默认为「新会话」" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submiting" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 重命名：sessions/edit 仅可改 title/status，且均为全量覆盖（title 不传会被清空、status 必传合法值） -->
    <el-dialog title="重命名会话" :visible.sync="renameVisible" width="480px" v-dialogDrag
               :modal-append-to-body="false" v-if="renameVisible">
      <el-form ref="renameForm" :model="renameForm" :rules="renameRules" label-width="90px">
        <el-form-item label="会话标题" prop="title">
          <el-input v-model="renameForm.title" maxlength="64" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="renameForm.status">
            <el-radio label="active">进行中</el-radio>
            <el-radio label="archived">已归档</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="renameVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submiting" @click="submitRename">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看消息：ctime 倒序（最新在前），只读 -->
    <el-dialog :title="msgTitle" :visible.sync="msgVisible" width="760px" v-dialogDrag
               :modal-append-to-body="false" v-if="msgVisible">
      <div v-loading="msgLoading" class="msg_list">
        <div v-for="m in msgList" :key="m.msg_id" :class="['msg_item', 'msg_' + m.role]">
          <div v-if="m.role === 'tool'" class="msg_bubble msg_tool">{{ m.content }}</div>
          <template v-else>
            <div class="msg_role">{{ m.role === 'user' ? '我' : '数字员工' }}</div>
            <div class="msg_bubble">{{ m.content }}</div>
          </template>
        </div>
        <div v-if="!msgLoading && !msgList.length" class="msg_empty">暂无消息</div>
      </div>
      <div slot="footer">
        <el-pagination
          @current-change="handleMsgPage"
          :current-page="msgPage"
          :page-size="msgPagesize"
          layout="total, prev, pager, next"
          :total="msgTotal"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { agentBody, isAdminAcc } from '../utils'

// 会话管理：列表/筛选/重命名/删除/历史消息只读查看
export default {
  name: 'AiAgentSessions',
  data() {
    return {
      queryForm: { agent_id: '' },
      agentOptions: [], // 数字员工下拉（limit=0 全量），个人账号可查到自己的
      tableData: [],
      loading: false,
      currentPage: 1,
      pagesize: 20,
      total: 0,
      submiting: false,
      addVisible: false,
      addForm: { agent_id: '', title: '' },
      addRules: {
        agent_id: [{ required: true, message: '请选择数字员工', trigger: 'change' }]
      },
      renameVisible: false,
      renameForm: { session_id: '', title: '', status: 'active' },
      renameRules: {
        title: [{ required: true, message: '请输入会话标题', trigger: 'blur' }]
      },
      msgVisible: false,
      msgLoading: false,
      msgSession: {},
      msgList: [],
      msgPage: 1,
      msgPagesize: 20,
      msgTotal: 0
    }
  },
  computed: {
    msgTitle() {
      return this.msgSession.title ? '会话消息 - ' + this.msgSession.title : '会话消息'
    },
    // 已归档的数字员工不可再新建会话（查询下拉仍保留全量便于检索历史）
    activeAgents() {
      return this.agentOptions.filter((a) => a.status === 'active')
    }
  },
  mounted() {
    // 管理员无 owner，常驻挂载下发 owner 型请求会 1002 弹错，跳过自动加载
    if (isAdminAcc()) return
    this.loadAgents()
    this.onSubmit()
  },
  methods: {
    loadAgents() {
      return this.$tools.asyncPost(this, this.$baseUrl.aiAgentAgentsList,
        agentBody({ limit: 0 })).then((res) => {
        if (res.data.code == 0) this.agentOptions = res.data.data.data || []
      }).catch(() => {})
    },
    agentName(id) {
      const a = this.agentOptions.find((x) => x.agent_id === id)
      return a ? (a.display_name || a.name) : (id || '-')
    },
    onSubmit() {
      this.loading = true
      const data = { page: this.currentPage, limit: this.pagesize }
      if (this.queryForm.agent_id) data.agent_id = this.queryForm.agent_id
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSessionsList, agentBody(data)).then((res) => {
        if (res.data.code == 0) {
          this.tableData = res.data.data.data || []
          this.total = res.data.data.total || 0
        }
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    onSearch() {
      this.currentPage = 1
      this.onSubmit()
    },
    resetQuery() {
      this.queryForm = { agent_id: '' }
      this.onSearch()
    },
    handleSizeChange(val) { this.pagesize = val; this.onSubmit() },
    handleCurrentChange(val) { this.currentPage = val; this.onSubmit() },
    // 供 agents Tab「查看会话」联动调用（index.vue 转发）
    async filterByAgent(agentId) {
      await this.loadAgents() // 每次联动都刷新，防 agents 增删后下拉过期
      this.queryForm.agent_id = agentId
      this.currentPage = 1
      this.onSubmit()
    },
    openAdd() {
      this.loadAgents() // 下拉可能因 agents Tab 增删而过期，打开时刷新
      this.addForm = { agent_id: this.queryForm.agent_id || '', title: '' }
      this.addVisible = true
      this.$nextTick(() => this.$refs.addForm && this.$refs.addForm.clearValidate())
    },
    submitAdd() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return
        this.submiting = true
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentSessionsAdd,
          agentBody({ agent_id: this.addForm.agent_id, title: this.addForm.title })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: res.data.msg || '创建成功' })
            this.addVisible = false
            this.currentPage = 1
            this.onSubmit()
          }
          this.submiting = false
        }).catch((err) => {
          this.submiting = false
          // 拦截器仅对业务码弹错，HTTP/网络层失败无提示，这里兜底
          if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        })
      })
    },
    openRename(row) {
      // 必须带上当前 status：edit 的 status 必填且仅接受 active/archived，缺省/非法值会 3004
      this.renameForm = { session_id: row.session_id, title: row.title || '', status: row.status || 'active' }
      this.renameVisible = true
      this.$nextTick(() => this.$refs.renameForm && this.$refs.renameForm.clearValidate())
    },
    submitRename() {
      this.$refs.renameForm.validate((valid) => {
        if (!valid) return
        this.submiting = true
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentSessionsEdit,
          agentBody({ session_id: this.renameForm.session_id,
                      title: this.renameForm.title, status: this.renameForm.status })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: res.data.msg || '更新成功' })
            this.renameVisible = false
            this.onSubmit()
          }
          this.submiting = false
        }).catch((err) => {
          this.submiting = false
          if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        })
      })
    },
    openMessages(row) {
      this.msgSession = row
      this.msgPage = 1
      this.msgVisible = true
      this.loadMessages()
    },
    loadMessages() {
      this.msgLoading = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentSessionsMessages,
        agentBody({ session_id: this.msgSession.session_id,
                    page: this.msgPage, limit: this.msgPagesize })).then((res) => {
        if (res.data.code == 0) {
          this.msgList = res.data.data.data || []
          this.msgTotal = res.data.data.total || 0
        }
        this.msgLoading = false
      }).catch(() => { this.msgLoading = false })
    },
    handleMsgPage(val) { this.msgPage = val; this.loadMessages() },
    handleDel(row) {
      this.$MessageBox.confirm('删除后该会话的全部消息将一并删除，确认删除？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentSessionsDel,
          agentBody({ session_id: row.session_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '删除成功' })
            if (this.tableData.length === 1 && this.currentPage > 1) this.currentPage -= 1
            this.onSubmit()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: err.response ? '请求失败，请稍后重试' : '网络异常，请稍后重试' })
        })
      }).catch(() => {})
    },
    fmtTime(s) {
      if (!s) return '-'
      return this.$tools.parserDateTime('datetime', s) || s.substring(0, 19).replace('T', ' ')
    }
  }
}
</script>

<style lang="less" scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // 表单下边距改由 toolbar 承担，保证表格前的间距不变
  margin-bottom: 22px;
  .toolbar_left {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  // 记忆 / 会话管理 子 Tab：选中样式与数字员工页一致（1px #12618A 下划线）
  .staff_tabs {
    display: flex;
    > span {
      display: flex;
      align-items: center;
      height: 32px;
      padding: 0 14px;
      font-size: 14px;
      font-weight: 500;
      color: #303133;
      cursor: pointer;
      border-bottom: 1px solid transparent;
      box-sizing: border-box;
      &.active {
        border-bottom-color: #12618A;
      }
    }
  }
  .query_form {
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
  }
}
.danger_text {
  color: #f56c6c;
}
.msg_list {
  min-height: 200px;
  max-height: 420px;
  overflow-y: auto;
}
.msg_item {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  // 裸 role 类名会被全局 .user{position:fixed} 污染，统一加前缀
  &.msg_user { align-items: flex-end; }
  &.msg_assistant { align-items: flex-start; }
  &.msg_tool { align-items: center; }
  .msg_role {
    font-size: 12px;
    color: #909399;
    margin-bottom: 2px;
  }
  .msg_bubble {
    max-width: 80%;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
    background: #f4f4f5;
    color: #303133;
  }
  &.msg_user .msg_bubble {
    background: #ecf5ff;
    color: #303133;
  }
  .msg_bubble.msg_tool {
    max-width: 100%;
    font-size: 12px;
    color: #909399;
    background: #fafafa;
  }
}
.msg_empty {
  padding: 40px 0;
  text-align: center;
  color: #909399;
}
</style>
